import useAuthStore from "../../store/AuthStore";
import {
  faUserPlus,
  faDashboard,
  faUser,
  faSignIn,
  faBlog,
} from "@fortawesome/free-solid-svg-icons";
import DesktopNavbar from "./DesktopNavBar";
import MobileNavbar from "./MobileNavBar";
import Cart from "../Cart/Cart";
const Navbar = ({ homeCSS }) => {
  const { user } = useAuthStore();
  const checkUser = user
    ? [
        { name: "Profile", url: "/user/my-dashboard/profile", icon: faUser },
        {
          name: "Dashboard",
          url: user.isAdmin ? "/admin" : "/user/my-dashboard",
          icon: faDashboard,
        },
      ]
    : [
        { name: "Login", url: "/login", icon: faSignIn },
        { name: "Get Started", url: "/sign-up", icon: faUserPlus },
      ];

  const mainLinks = [
    { name: "Insight", url: "/insights", icon: faBlog },
    ...checkUser,
  ];

  return (
    <>
      <DesktopNavbar mainLinks={mainLinks} homeCSS={homeCSS} />
      <MobileNavbar />
    </>
  );
};

export default Navbar;
